// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSoundOutlinedSvg from "@fishx/icons-svg/es/asn/PSoundOutlined";
import FishxIcon from '../components/FishxIcon';

var PSoundOutlined = function PSoundOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSoundOutlinedSvg
  }));
};

PSoundOutlined.displayName = 'PSoundOutlined';
export default React.forwardRef(PSoundOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSoundOutlined.js
// module id = 3647
// module chunks = 0